<rid-reading-basis-instruction-mode
  class="h-dvh"
  instruction="Lees het woord hardop voor"
  [pace]="pace()"
  [words]="[
    {
      word: ['leeuw'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
    },
    {
      word: ['tijger'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
    },
    {
      word: ['zebra'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/reading-basis'])"
/>
